import MAudioPlayer from './index.vue';

MAudioPlayer.install = app => {
  app.component(MAudioPlayer.name, MAudioPlayer);
};

export default MAudioPlayer;
